module.exports = __webpack_public_path__ + "img/ScreenCap_Over_36dp.fc909f8f.svg";